import type { RouteObject } from 'react-router-dom'

import type { NavItem } from '@/app/registry'

import { LoginPage } from './LoginPage'
import { SetupPage } from './SetupPage'
import { AuthActionPage } from './ActionPage'

export const publicRoutes: RouteObject[] = [
  { path: '/login', element: <LoginPage /> },
  { path: '/setup', element: <SetupPage /> },
  { path: '/invite', element: <AuthActionPage /> },
  { path: '/reset-password', element: <AuthActionPage /> },
  { path: '/confirm-email', element: <AuthActionPage /> },
  { path: '/forgot-password', element: <AuthActionPage /> },
  { path: '/account/complete', element: <AuthActionPage /> },
]

export const routes: RouteObject[] = []
export const nav: NavItem[] = []
